module.exports = __webpack_public_path__ + "static/erik-bernhardsson-400w-103018-d03657dbff46ebece72ea42da96d33fd.jpg";